/**
 * Created by xy on 2018/8/29.
 */
import React,{Component} from "react"
import {Toast,ListView,Modal,NavBar, SearchBar,Icon} from 'antd-mobile';
import {allOrderList} from "../../service/orderService";
import SecOrderModal from '../../components/SecOrderModal';
import './style.less';
let pageNo = 1;
let pageSize = 10;
export default class SearchOrderList extends Component{
    constructor(props) {
        super(props);
        
        this.state={
            searchVal:"",
            data:[],
            isLoading: true,
            passTotal: "",
            
        }
    }

    componentDidMount() {
        pageNo = 1;
        this.getOrderList("");
    }
   getOrderList(keyWords){
       let params = {
            keywords:keyWords,
            pageSize:pageSize,
            pageNo:pageNo,
        };
        console.log(params)
        Toast.loading("正在加载",0);
        allOrderList(params).then((res) => {
            Toast.hide();
            
                if(res.data.code == "000000"){
                    console.log(res);
                    pageNo = 1;
                    this.setState({data: res.data.data.list, passTotal: res.data.data.pageCount});
                    this.refs.SecOrderModal.componentDidMount();
                    if (pageNo * pageSize >= this.state.passTotal) {
                        this.setState({
                            isLoading: false,
                        });
                    }
                }else{
                    console.log(res.msg)
                }
                
        }).catch(function (error) {
            console.log(error);
        });
   };
   //上拉加载
   _onEndReached = (callback) => {
    if (pageNo * pageSize >= this.state.passTotal) {
        this.setState({
            isLoading: false,
        });
        return false;
    }
    let params = {
        keywords:this.state.searchVal,
        pageSize: pageSize,
        pageNo: ++pageNo,
    };
    allOrderList(params)
        .then((res) => {
            const allData = [...this.state.data, ...res.data.data.list];
            callback && callback(allData);
            this.setState({data: allData, passTotal: res.data.data.pageCount});
        }).catch(function (error) {
        console.log(error);
    });
};
    searchGo(value) {
        this.setState({searchVal:value})
        this.getOrderList(value);

        console.log(value)
    }
    // 搜索
    searchChange(value) {
        this.setState({searchVal: value})
    }
    goPage(v){
        this.props.history.push(`/searchOrderDetail/${v.orderNo}`)
    }
    render() {
        return (
            <div className="SearchOrderList">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >查看订单</NavBar>
                <div className="search">
                    <SearchBar
                        value={this.state.searchVal}
                        placeholder="请输入订单号或者出发地/目的地"
                        onSubmit={value => this.searchGo(value)}
                        showCancelButton
                        onChange={value => this.searchChange(value)}
                    />
                </div>
               
                    <SecOrderModal
                     ref="SecOrderModal"
                    data={this.state.data}
                    goPage={this.goPage.bind(this)}
                    _onEndReached={this._onEndReached.bind(this)}
                    isLoading={this.state.isLoading}
                    />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/SearchOrderList/index.js